import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { styled, Theme } from '@mui/material';

// Shared picker styles used across rate card table components
const pickerStyles = (theme: Theme) => ({
  width: '100%',
  '& .MuiInputBase-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiInputBase-input': {
    paddingTop: '4px!important',
    paddingBottom: '4px!important',
    paddingLeft: '0px!important',
    paddingRight: '0px!important',
    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
  '& .MuiFormHelperText-root ': {
    marginLeft: '0px!important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '0',
    borderBottom: '1px solid #999999',
    borderRadius: '0',
  },
});

export const StyledDatePicker = styled(DatePicker)(({ theme }) => pickerStyles(theme));

export const StyledTimePicker = styled(TimePicker)(({ theme }) => pickerStyles(theme));
